import { createModule } from '~/factories/store'
import actions from '~/store/modules/shared/user/actions'
import getters from '~/store/modules/shared/user/getters'
import mutations from '~/store/modules/shared/user/mutations'
import state from '~/store/modules/shared/user/state'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
